import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IGlobalStoreReducers } from './initStore';
import { ApryseSDK } from '../pdf/ApryseSDK';

export interface ISelectedStateState {
    stateName: string;
}

export const selectedStateSlice = createSlice({
    name: 'selectedState',
    initialState: {
        stateName: ApryseSDK.ToolsENUM.PAN,
    } as ISelectedStateState,
    reducers: {
        changeStateName: (state, action: PayloadAction<string>) => {
            state.stateName = action.payload;
        },
    },
});

export const { changeStateName } = selectedStateSlice.actions;
export const selectedStateName = (state: IGlobalStoreReducers) => state.selectedState.stateName;

export default selectedStateSlice.reducer;
